import React, { useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";

const WhatsAppWidget = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-50">
      {/* Botón flotante de WhatsApp */}
      <button
        className="bg-green-500 text-white p-3 sm:p-4 rounded-full shadow-lg hover:bg-green-600 transition-all flex items-center justify-center"
        onClick={() => setIsOpen(!isOpen)}
      >
        <FaWhatsapp className="text-2xl sm:text-3xl" />
      </button>

      {/* Modal flotante */}
      {isOpen && (
        <div className="absolute bottom-20 right-0 bg-white shadow-xl rounded-2xl p-3 sm:p-4 w-64 sm:w-72">
          <div className="flex flex-col items-center text-center">
            {/* Imagen del asesor */}
            <img
              src="https://celebratufiesta.com.co/wp-content/uploads/2025/02/Floating-Robot-scaled.jpg"
              alt="Asesor"
              className="w-14 h-14 sm:w-16 sm:h-16 rounded-full mb-2"
            />
            <p className="text-gray-700 font-medium text-sm sm:text-base">
              ¿En qué te puedo ayudar?
            </p>

            {/* Botón de contacto en WhatsApp */}
            <a
              href="https://wa.me/+573175421859"
              className="bg-orange-500 text-white font-semibold px-3 py-2 mt-3 text-xs sm:text-sm rounded-full flex items-center justify-center gap-2 hover:bg-orange-600 transition"
              target="_blank"
              rel="noopener noreferrer"
            >
              📞 Comunícate con nosotros!
            </a>

            {/* Botón de cerrar */}
            <button
              className="mt-2 text-gray-600 hover:text-gray-800"
              onClick={() => setIsOpen(false)}
            >
              <IoIosArrowDown className="text-lg sm:text-xl" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default WhatsAppWidget;
